// Per-neighbourhood SEO landing page content. Warm, genuine, locally specific.

export const AREA_WHY = [
  "Locally owned & operated since 2019",
  "Registered, insured & bondable — police checks available when required",
  "Trained in WHMIS, GBAC, Workplace Health & Safety and AODA",
  "A free in-home visit before any pricing — no surprises",
  "4.9★ rated by Hamilton-area neighbours",
];

export const AREA_DETAILS = [
  {
    slug: "hamilton",
    name: "Hamilton",
    region: "Hamilton, Ontario",
    image: "/hero-cleaner.jpg",
    headline: "House cleaning in Hamilton, done with heart",
    lead: "Warm, dependable home cleaning for busy Hamilton households — from the Mountain to the lower city.",
    cardBlurb: "From the Mountain to the lower city — dependable cleaning tailored to your home.",
    body: [
      "Hamilton is a city of wonderfully different homes — century houses in Durand and Kirkendall, family bungalows across the Mountain, and modern builds closer to the water. Wisp cleans them all with the same care, tailoring every visit to the way your household actually lives.",
      "Whether you'd like a weekly or bi-weekly rhythm, a one-time deep clean, or a move in/out reset, we start with a free in-home visit so your quote is fair and there are no surprises. Locally owned since 2019, insured and bondable, and trusted by neighbours right across the city.",
    ],
    neighbourhoods: ["The Mountain", "Westdale", "Durand", "Kirkendall", "Corktown", "Ainslie Wood"],
    faqs: [
      { q: "Do you serve all of Hamilton?", a: "We serve homes and small offices across Hamilton and the surrounding communities. If you're nearby, there's a very good chance we can help — reach out and we'll confirm right away." },
      { q: "How soon can you visit?", a: "We can usually arrange your free in-home visit within a few days. Call or text 289-799-2690 and we'll find a time that suits you." },
    ],
  },
  {
    slug: "ancaster",
    name: "Ancaster",
    region: "Ancaster, Ontario",
    image: "/tagline-livingroom.jpg",
    headline: "Detail-focused cleaning for Ancaster homes",
    lead: "Careful, respectful cleaning for Ancaster's executive and heritage homes, where quality and trust come first.",
    cardBlurb: "Executive and heritage homes where quality and trust come first.",
    body: [
      "From the historic charm of Ancaster Village to the spacious executive homes around the Meadowlands and beyond, Ancaster homes deserve a careful, respectful touch. Wisp brings exactly that — thorough, consistent cleaning with the thoughtful finishing touches our clients love.",
      "Many Ancaster families book us for recurring weekly or bi-weekly visits, while others call for a one-time deep clean or a move in/out. Either way, we begin with a free in-home visit so your pricing is honest and truly tailored to your home.",
    ],
    neighbourhoods: ["Ancaster Village", "Meadowlands", "Parkview Heights", "Spring Valley", "Old Ancaster"],
    faqs: [
      { q: "Do you clean larger executive homes in Ancaster?", a: "Absolutely — larger and detail-rich homes are a big part of what we do. Your free in-home visit lets us plan the right amount of time and focus for your space." },
      { q: "Can you keep the same team each visit?", a: "We do our best to keep familiar faces on your home so you feel comfortable and the results stay consistent." },
    ],
  },
  {
    slug: "dundas",
    name: "Dundas",
    region: "Dundas, Ontario",
    image: "/life-family.jpg",
    headline: "Caring home cleaning in Dundas",
    lead: "Genuine, detail-focused cleaning for Dundas's character homes and valley households.",
    cardBlurb: "Character homes and modern residences throughout the valley.",
    body: [
      "Nestled in the valley, Dundas is full of character — century homes near the downtown core and modern residences tucked against the escarpment. Wisp cleans each with real care, protecting the little details that make these homes special.",
      "From dependable recurring visits to seasonal deep cleans and move in/out cleaning, it all starts with a free in-home visit. Locally owned, insured and bondable, and proud to look after our Dundas neighbours.",
    ],
    neighbourhoods: ["Downtown Dundas", "University Gardens", "Pleasant Valley", "Governor's Road", "Dundas Valley"],
    faqs: [
      { q: "Do you clean older, character homes?", a: "Yes — we love them. We clean with extra care around original features and fragile finishes, and we'll always let you know if something falls outside what we can safely guarantee." },
      { q: "Is the first visit really free?", a: "It is — no obligation and no pressure. It's simply the best way for us to understand your home and give you honest, accurate pricing." },
    ],
  },
  {
    slug: "stoney-creek",
    name: "Stoney Creek",
    region: "Stoney Creek, Ontario",
    image: "/life-family-inclusive.jpg",
    headline: "Reliable recurring cleaning in Stoney Creek",
    lead: "Dependable weekly and bi-weekly cleaning for Stoney Creek families across the mountain brow.",
    cardBlurb: "Spacious family homes across the mountain brow — ideal for recurring cleans.",
    body: [
      "From the newer, spacious homes of Summit Park and Hannon to established neighbourhoods in Heritage Green and along the escarpment, Stoney Creek families love a dependable cleaning rhythm — and that's exactly our specialty.",
      "Weekly, bi-weekly or monthly maintenance cleans, one-time deep cleans, and move in/out cleaning are all tailored to your home after a free in-home visit. No surprises — just a fresh home and more of your weekend back.",
    ],
    neighbourhoods: ["Upper Stoney Creek", "Summit Park", "Hannon", "Heritage Green", "Battlefield", "Winona"],
    faqs: [
      { q: "What's the most popular schedule here?", a: "Bi-weekly maintenance cleans are the favourite for busy Stoney Creek households, but we happily do weekly, monthly, or one-time cleans too." },
      { q: "Do you cover Summit Park and Hannon?", a: "Yes — the newer homes in Summit Park and Hannon are right in our service area and a wonderful fit for recurring cleaning." },
    ],
  },
  {
    slug: "binbrook",
    name: "Binbrook",
    region: "Binbrook, Ontario",
    image: "/life-kids.jpg",
    headline: "Home cleaning for busy Binbrook households",
    lead: "Friendly, dependable cleaning for Binbrook's growing community of larger family homes.",
    cardBlurb: "A growing community of larger properties and busy households.",
    body: [
      "Binbrook has grown into a wonderful community of larger properties and busy families near Lake Niapenco and the village core. When life is full, a dependable clean makes all the difference — and that's where Wisp comes in.",
      "Whether you'd like a recurring rhythm or a one-time refresh, we start with a free in-home visit so your quote fits your home and household. Friendly, insured and locally trusted.",
    ],
    neighbourhoods: ["Binbrook Village", "Fletcher Creek", "Cherry Hill", "Fifty Road area"],
    faqs: [
      { q: "Do you travel out to Binbrook?", a: "We do — Binbrook is part of our regular service area, and we plan our routes so we can stay reliable and on time for you." },
      { q: "Can you handle larger family homes?", a: "Definitely. Your free in-home visit helps us size the visit correctly so nothing feels rushed." },
    ],
  },
  {
    slug: "waterdown",
    name: "Waterdown",
    region: "Waterdown, Ontario",
    image: "/life-coffee.jpg",
    headline: "A reliable cleaning partner in Waterdown",
    lead: "On-time, caring home cleaning for Waterdown families who want one less thing to carry.",
    cardBlurb: "Family neighbourhoods looking for a reliable recurring cleaning partner.",
    body: [
      "Waterdown blends small-town warmth with growing family neighbourhoods around Smokey Hollow and the downtown core. Wisp fits right in — dependable, on-time, and genuinely caring about your home.",
      "From weekly and bi-weekly visits to deep cleans and move in/out cleaning, everything begins with a free in-home visit. Locally owned since 2019, insured and bondable.",
    ],
    neighbourhoods: ["Downtown Waterdown", "Smokey Hollow", "Flamborough", "Rockton area"],
    faqs: [
      { q: "How do you keep visits on time?", a: "We plan our days around the neighbourhoods we serve, and we ask for a 2-hour arrival window so weather and traffic never make us feel rushed. We'll keep you posted along the way." },
      { q: "Do you offer one-time cleans too?", a: "Yes — one-time deep cleans and move in/out cleaning are available alongside our recurring visits." },
    ],
  },
  {
    slug: "burlington",
    name: "Burlington",
    region: "Burlington, Ontario",
    image: "/life-professional.jpg",
    headline: "Polished cleaning for Burlington homes & offices",
    lead: "A clean, welcoming space for Burlington homes and small workspaces — with a professional finish.",
    cardBlurb: "Homes and small offices seeking a polished, professional finish.",
    body: [
      "From lakeside neighbourhoods in Aldershot to family homes and small workspaces across Burlington, our clients appreciate a clean, welcoming space that's ready for whatever the day brings. Wisp delivers that polished, professional finish.",
      "We offer residential and small-office cleaning, recurring or one-time, always starting with a free in-home visit so pricing is clear and tailored. Insured, bondable, and trusted by neighbours.",
    ],
    neighbourhoods: ["Aldershot", "Downtown Burlington", "The Orchard", "Alton Village", "Roseland"],
    faqs: [
      { q: "Do you clean small offices in Burlington?", a: "Yes — we clean small offices and workspaces with flexible before/after-hours scheduling, so your team and clients always walk into a spotless space." },
      { q: "Can you do before or after business hours?", a: "We can. Many small-office clients prefer early morning or evening cleans, and we'll build a schedule that works around your day." },
    ],
  },
];

export const getArea = (slug) => AREA_DETAILS.find((a) => a.slug === slug);
